import{NgModule}from'@angular/core'
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatRadioModule} from '@angular/material/radio';
import {MatButtonModule} from '@angular/material/button';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatIconModule} from '@angular/material/icon';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatCardModule} from '@angular/material/card';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatMenuModule} from '@angular/material/menu';
import {MatListModule} from '@angular/material/list';
import {MatTableModule} from '@angular/material/table';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule} from '@angular/material';
import {MatStepperModule} from '@angular/material/stepper';
import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
import { AmazingTimePickerModule } from 'amazing-time-picker'; 
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatTabsModule} from '@angular/material/tabs';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatPaginatorModule}from'@angular/material';
import {MatDialogModule} from '@angular/material/dialog';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatSortModule} from '@angular/material/sort';
import {MatCheckboxModule} from '@angular/material/checkbox';
@NgModule({
    imports:[
        MatInputModule,
        MatSelectModule,
        MatRadioModule,
        MatButtonModule,
        MatGridListModule,
        MatToolbarModule,
        MatIconModule,
        MatCardModule,
        MatSidenavModule,
        MatMenuModule,
        MatListModule,
        MatTableModule,
        MatSnackBarModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatStepperModule,
        NgxMaterialTimepickerModule,
        AmazingTimePickerModule,
        MatProgressSpinnerModule,
        MatTabsModule,MatExpansionModule,
        MatPaginatorModule,MatDialogModule,
        MatTooltipModule,MatSortModule,
        MatCheckboxModule
        
    ],
    exports:[
        MatInputModule,
        MatSelectModule,
        MatRadioModule,
        MatButtonModule,
        MatGridListModule,
        MatToolbarModule,
        MatIconModule,
        MatCardModule,
        MatSidenavModule,
        MatMenuModule,
        MatListModule,
        MatTableModule,
        MatSnackBarModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatStepperModule,
        NgxMaterialTimepickerModule,
        AmazingTimePickerModule,
        MatProgressSpinnerModule,
        MatTabsModule,MatExpansionModule,
        MatPaginatorModule,MatDialogModule,MatTooltipModule,MatSortModule,
        MatCheckboxModule
    ]

})
export class MaterialModule{}